// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3lEbi","productName":"Table_productName__2BW7J"};